export default __webpack_public_path__ + "static/media/hammadprof.ad96a81e.png";